import Icon from '../components/Icon.vue'

Icon.register({
  store: {
    width: 616,
    height: 512,
    paths: [
      {
        d: 'M602 118.6c33.6 53.6 3.8 128-59 136.4-4.5 0.6-9 0.9-13.7 0.9-29.5 0-55.7-13-73.8-33.1-18 20.1-44.2 33.1-73.8 33.1-29.5 0-55.8-13-73.8-33.1-18 20.1-44.2 33.1-73.8 33.1-29.5 0-55.8-13-73.8-33.1-18 20.1-44.2 33.1-73.8 33.1-4.6 0-9.2-0.3-13.7-0.9-62.6-8.5-92.3-82.9-58.8-136.4l64.9-103.6c5.8-9.3 16.1-15 27.1-15h404c11 0 21.3 5.7 27.1 15zM529.5 288c6.1 0 12.1-0.4 18.2-1.2 5.6-0.7 11-2 16.4-3.6v196.8c0 17.7-14.3 32-32 32h-448c-17.7 0-32-14.3-32-32v-196.8c5.3 1.5 10.8 2.8 16.4 3.6 5.9 0.8 12 1.2 18 1.2 10 0 19.9-1.6 29.5-3.8v99.8h384v-99.8c9.6 2.3 19.5 3.8 29.5 3.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/store.js
// module id = 1956
// module chunks = 0